import sanitizeHtml from 'sanitize-html';

// Remove all html tags and convert into plaintext
// @param str:string
// @param allowedTags:array
// @param allowedAttributes:object
// @return string

const HTMLSanitizer = (
  str: string,
  allowedTags = [],
  allowedAttributes = {},
): string => {
  const opts = {
    allowedTags,
    allowedAttributes,
  };

  return str ? sanitizeHtml(str, opts) : '';
};

export default HTMLSanitizer;
